import { makePopupApi } from '../utils/plugin'
import prompt from '../managers/prompt'

export default makePopupApi('prompt', prompt)
